document.addEventListener('DOMContentLoaded', function() {
  console.log('carico il main product js');

  function updateProductDescription(variantId) {
    //console.log(variantId);
    var description = variantDescriptions[variantId];

    if (description) {
      document.querySelector('.product-info__description').innerHTML = description;
    } else {
      document.querySelector('.product-info__description').innerHTML = productDescription;
    }
  }

  async function updateAccordionContent(variantId) {
    var manualiUrls = variantContent[variantId].manuali;
    var html = '<ul class="manuali">';
  
    // Usa un ciclo for...of che è compatibile con async/await
    for (const file of manualiUrls) {
      try {
        // Fai una richiesta HEAD per ottenere solo gli header
        const response = await fetch(file.url, { method: 'HEAD' });
  
        // Recupera il valore dell'intestazione 'Content-Length'
        const contentLength = response.headers.get('Content-Length');
        let filesize = 0;
  
        if (contentLength) {
          //console.log('Dimensione del file (in byte):', contentLength);
          //console.log('Dimensione del file in KB:', (contentLength / 1024).toFixed(2), 'KB');
          //console.log('Dimensione del file in MB:', (contentLength / (1024 * 1024)).toFixed(2), 'MB');
          
          // Calcola la dimensione in MB
          filesize = (contentLength / (1024 * 1024)).toFixed(2);
        } else {
          console.log('Dimensione del file non disponibile');
          filesize = 'ND';
        }
  
        // Aggiungi il file alla lista HTML
        html += `<li><div class="descrizione">${downloadIconHtml} ${file.alt} (pdf - ${filesize} MB)</div><div><a href="${file.url}" target="_blank">Download</a></div></li>`;
  
      } catch (error) {
        console.error('Errore nel recupero della dimensione del file:', error);
      }
    }
  
    html += '</ul>';
  
    // Aggiungi l'HTML generato per questa variante
    if (variantContent[variantId]) {
      document.querySelector('.accordion-box .accordion:nth-child(1) .accordion__content').innerHTML = `<div class='prose'><span class='close'>${closeIconHtml}</span>${variantContent[variantId].descrizione}</div>`;
      document.querySelector('.accordion-box .accordion:nth-child(2) .accordion__content').innerHTML = `<div class='prose'><span class='close'>${closeIconHtml}</span>${variantContent[variantId].accessori}</div>`;
      document.querySelector('.accordion-box .accordion:nth-child(3) .accordion__content').innerHTML = `<div class='prose'><span class='close'>${closeIconHtml}</span>${html}</div>`;
      document.querySelector('.accordion-box .accordion:nth-child(4) .accordion__content').innerHTML = `<div class='prose'><span class='close'>${closeIconHtml}</span>${variantContent[variantId].sicurezza}</div>`;
      attachCloseEvent();
    } else {
      console.warn("Nessun contenuto disponibile per questa variante.");
    }
  }
  
  var variantRadios = document.querySelectorAll('input[name="option1"]');

  // Recupera l'ID della variante per il prodotto semplice
  var productVariantElement = document.getElementById('product-variant');
  if (productVariantElement) {
    var variantId = productVariantElement.getAttribute('data-variant-id');
    console.log("ID della variante (prodotto semplice):", variantId);
    updateProductDescription(variantId);
    updateAccordionContent(variantId);
  }

  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      console.log(this.value);
      var variantId = this.getAttribute('data-variant-id');
      
      updateProductDescription(variantId);
      updateAccordionContent(variantId);
    });
  });


  function attachCloseEvent() {
    var closeButtons = document.querySelectorAll('.accordion-box .close');
    
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        document.querySelectorAll('.accordion[open] summary').forEach(function(summary) {
          summary.click();
        });
      });
    });
  }



  // Aggiorna la descrizione e i dati della variante selezionata di default
  var defaultSelectedRadio = document.querySelector('input[name="option1"]:checked');
  if (defaultSelectedRadio) {
    var defaultVariantId = defaultSelectedRadio.getAttribute('data-variant-id');

    updateProductDescription(defaultVariantId);
    updateAccordionContent(defaultVariantId);
  }
});